const defaultState = {
  report: {},
  error: null,
  fetching: false,
  fetched: false
};

const getRiskPredictorScoreReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'RISK_PREDICTOR_SCORE_CLEAR': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: null
      };
    }
    case 'RISK_PREDICTOR_SCORE_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true, report: {}
      };
    }
    case 'RISK_PREDICTOR_SCORE_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: action.payload.data
      };
    }
    case 'RISK_PREDICTOR_SCORE_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        report: {},
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getRiskPredictorScoreReducer;


// WEBPACK FOOTER //
// ./src/reducers/getRiskPredictorScore.js